import React from "react";
import PropTypes from "prop-types";
import { useUser } from "~/Context/userContext";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./TrackFooter.less";
import TrackFavorite from "~/Components/Icons/TrackFavorite";
import MediaSourceIcon from "~/Components/Icons/MediaSourceIcon";
// import TrackAddPlaylist from "~/Components/Icons/TrackAddPlaylist";
import AddToPlaylistModal from "~/Components/Elements/AddToPlaylistModal";
import AdditionalFileUnder from "~/Components/Elements/AdditionalFileUnder";

const TrackFooter = ({ track, showTaggingButton = true }) => {
  const { state: userState } = useUser();
  return (
    <div className="track-footer">
      <div className="footer-left">
        <div className="footer-item footer-track-favorite">
          <TrackFavorite track={track} />
        </div>
        <div className="footer-item">
          <AddToPlaylistModal trackId={track.id} />
        </div>
        {showTaggingButton && (
          <div className="footer-item">
            <AdditionalFileUnder trackId={track.id} compact />
          </div>
        )}
        {track.sc_url && (
          <div className="footer-item">
            <MediaSourceIcon track={track} />
          </div>
        )}

        {userState.user && userState.user.dir === track.chimdir && (
          <div className="footer-item footer-track-edit-icon">
            <Link to={`/${track.id}/edit`} title="Edit this track">
              Edit <FontAwesomeIcon icon={["fas", "edit"]} style={{ marginLeft: "6px" }} />
            </Link>
          </div>
        )}
      </div>
      <div className="footer-right">
        <span className="edit">
          {userState.user && userState.user.dir === "ryan" ? (
            <a style={{ fontSize: 11, marginRight: 12 }} target="_blank" rel="noopener noreferrer" href={`http://localhost:8092/media/${track.id}`}>
              Edit Media
            </a>
          ) : null}
        </span>
        <div className="posted-date">Posted: {track.date}</div>
      </div>
    </div>
  );
};

TrackFooter.propTypes = {
  track: PropTypes.object.isRequired,
  showTaggingButton: PropTypes.bool,
};

export default TrackFooter;
